/** @file Rounds an angle to a multiple of a step (Shift-constrained rotation uses 15 degrees). */

/** Returns deg rounded to the nearest multiple of step (default 15); a step <= 0 leaves deg unchanged. */
export function snapAngle(deg: number, step = 15): number {
  return step > 0 ? Math.round(deg / step) * step : deg;
}
